import { Action } from "@packages/shared-types";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useHasPermission } from "@/hooks/useAccessControl";
import { BackfillCard } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/BackfillCard";
import { CategoryManager } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/CategoryManager";
import { CattlePricesCard } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/CattlePricesCard";
import { MappingManager } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/MappingManager";
import { OpeningBalanceCard } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/OpeningBalanceCard";
import { VerifierCard } from "@/routes/_auth/app/_app/org/$orgId/financial/-components/VerifierCard";
import { SettingsLayout } from "@/routes/_auth/app/_app/org/$orgId/settings/-components/SettingsLayout";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/settings/financial/",
)({
	component: FinancialSettingsPage,
});

function FinancialSettingsPage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const canManageSettings = useHasPermission(orgId)(
		Action.MANAGE_FINANCE_SETTINGS,
	);

	return (
		<SettingsLayout
			activeTab="financial"
			title={t("financial.nav.title")}
			testId="financial-settings-container"
			contentTestId="financial-settings-content"
		>
			<div className="flex flex-col gap-6">
				{canManageSettings ? (
					<>
						<OpeningBalanceCard orgId={orgId} />
						<CattlePricesCard orgId={orgId} />
						<div className="grid gap-6 lg:grid-cols-2">
							<BackfillCard orgId={orgId} />
							<VerifierCard orgId={orgId} />
						</div>
						<CategoryManager orgId={orgId} />
						<MappingManager orgId={orgId} />
					</>
				) : (
					<p className="text-base-content/70">
						{t("errors.forbidden", t("common.error"))}
					</p>
				)}
			</div>
		</SettingsLayout>
	);
}
